export default "__VITE_ASSET__BD1InS18__"